import React, { useState } from "react";

import { getLanguageFromLocalStorage, goTo, triggerTrengo, useTranslation, useUserContext } from "utils";

import { COUNTRY_CODE, DEFAULT_WEBINAR_LINK, LANGUAGE_CODE } from "consts";

import { Button, Col, Icon, Row } from "components";

const ContactFooter: React.FC = () => {
  const { t } = useTranslation(["dashboard", "meta"]);
  const { user } = useUserContext();

  const [trengo, setTrengo] = useState(false);

  const webinarLink = () => {
    const locale = getLanguageFromLocalStorage();

    if (locale === LANGUAGE_CODE.ZULU) {
      return "https://www.klim.eco/en/farmers/webinars";
    }

    if (locale === LANGUAGE_CODE.ENGLISH) {
      return "https://www.klim.eco/en/farmers/webinars";
    }

    if (locale === LANGUAGE_CODE.POLISH) {
      return "https://www.klim.eco/en/farmers/webinars";
    }

    return DEFAULT_WEBINAR_LINK;
  };

  const contactButtons = [
    user?.farm?.country !== COUNTRY_CODE.POLAND
      ? {
          translationKey: "contact.webinar",
          iconName: "tabler/world-longitude",
          action: () => goTo(null, null, webinarLink(), true),
        }
      : undefined,
    {
      translationKey: "contact.contact",
      iconName: "tabler/writing",
      action: () => triggerTrengo("email", trengo, setTrengo),
    },
    {
      translationKey: "contact.faqs",
      iconName: "tabler/mail",
      action: () => triggerTrengo("help_center", trengo, setTrengo),
    },
    {
      translationKey: "contact.career",
      iconName: "klim/heart-handshake",
      action: () => window.open("https://www.klim.eco/karriere", "_blank", "noopener,noreferrer"),
    },
    {
      translationKey: "contact.feedback",
      iconName: "tabler/help",
      action: () => goTo(null, null, process.env.REACT_APP_TYPEFORM, true),
    },
  ];

  return (
    <section className="padding-top-150 padding-bottom-400 margin-bottom-350">
      <Row>
        <Col sm={24} xs={24}>
          <h3>{t("info.title")}</h3>
        </Col>
      </Row>
      <Row>
        <Col sm={12} xs={24}>
          <p className="deep-black-text">{t("info.description")}</p>
        </Col>
        <Col sm={12} xs={24}>
          {contactButtons.map((button) =>
            button ? (
              <Button key={button.iconName} className="contact-footer-button" onClick={button.action}>
                <Icon iconName={button.iconName} />
                <div className="contact-footer-button-text">{t(button.translationKey)}</div>
                <Icon iconName="tabler/chevron-right" />
              </Button>
            ) : null
          )}
        </Col>
      </Row>
    </section>
  );
};

export default ContactFooter;
